module.exports = __webpack_public_path__ + "img/pista2.3b64f7f2.png";